export default __webpack_public_path__ + "static/media/notification-icon.56819075.svg";